// Define the configuration object as the source of truth
export const featureFlags = {
    PLACES_PROXY: {
        name: 'resolve address autocomplete through the backend places proxy',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    COUNTER_SIGN_ON_SEND: {
        name: 'provider counter-sign on send',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    },
    WIP_AMENDMENTS: {
        name: 'save for later amendments made to an approved agreement',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    RENAME_AGREEMENT_ENDPOINT: {
        name: 'New endpoint dedicated for renaming agreement name',
        openInE2eTests: true,
        owner: 'meital@sayanchor.com'
    },
    DISABLE_BILLING_SCAN: {
        name: 'Kills bill...ing',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    PROPOSAL_EXPIRATION_DATE_BULK_UPLOAD: {
        name: 'proposal expiration date bulk upload',
        openInE2eTests: false,
        owner: 'unset'
    },
    AUTOMATIC_STAGES: {
        name: 'per-stage scheduling on bill-in-stages services',
        openInE2eTests: true,
        owner: 'ben@sayanchor.com'
    },
    CONNECTED_APPS_PAGE: {
        name: 'new page that shows all connected integrations',
        openInE2eTests: true,
        owner: 'meital@sayanchor.com'
    },
    INVOICE_PDF_SCOUT: {
        name: 'use scout-pdf service to download invoice pdf',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    PER_LINE_ITEM_REFUNDS: {
        name: 'per-line-item refund modal (ANCR-3122)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    KYB_UPDATED_FLOW: {
        name: 'optimized KYB inquiry template (ANCR-869)',
        openInE2eTests: false,
        owner: 'anna.y@sayanchor.com'
    },
    INTERCOM_JWT_IDENTITY: {
        name: 'Use Intercom signed-JWT identity verification (replaces user_hash HMAC)',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    TEMPLATE_VARIABLES: {
        name: 'Template variables in Agreement Studio',
        owner: 'leeor@sayanchor.com',
        openInE2eTests: false
    },
    CUSTOM_VARIABLES: {
        name: 'custom (user-defined) template variables',
        owner: 'leeor@sayanchor.com',
        openInE2eTests: true
    },
    UPDATE_DEFAULT_TOS_FE: {
        name: 'content of Anchor default tos changed',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    HELP_ME_DRAFT: {
        name: 'agentic proposal drafting pane in AgreementStudioProposalMode',
        openInE2eTests: false,
        owner: 'ahuvi@sayanchor.com'
    },
    BULK_AGENTIC_DRAFTS: {
        name: 'bulk agentic drafting pane on DraftsDashboard (ANCR-36)',
        openInE2eTests: false,
        owner: 'ahuvi@sayanchor.com'
    },
    HELP_ME_WRITE_NOTIFICATIONS: {
        name: 'AI-assisted "help me write" drawer for notification settings (ANCR-1500)',
        openInE2eTests: true,
        owner: 'daniel@sayanchor.com'
    },
    EDIT_PROPOSAL_IN_PLACE: {
        name: 'edit proposal in place',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    ACTIVITY_LOG_V2: {
        name: 'use PostgreSQL-backed V2 activity log endpoint instead of Neo4j-backed V1',
        openInE2eTests: true,
        owner: 'elad@sayanchor.com'
    },
    ACTIVITY_LOG_DUAL_CALL: {
        name: 'dual-call old + new activity-log endpoints and post diffs to Slack (temporary parity-validation shim)',
        openInE2eTests: false,
        owner: 'elad@sayanchor.com'
    },
    INVOICES_PM_COLUMN: {
        name: 'show payment method column in invoices table',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    ME_V2_EXCLUDE_ACCOUNTANT_WORKSPACES: {
        name: 'use v2 /me endpoint that excludes accountant workspaces for faster loading',
        openInE2eTests: true,
        owner: 'danielc@sayanchor.com'
    },
    PAYOUTS_EXTERNAL_API: {
        name: 'move the FE to use the new payout endpoint',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    EXTERNAL_INVOICES_ENDPOINT: {
        name: 'move the FE to use the new invoice endpoints',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    INVOICE_METRICS_COLUMNAR_ENDPOINT: {
        name: 'read invoice dashboard metrics from the columnar scout endpoint',
        openInE2eTests: false,
        owner: 'aviv@sayanchor.com'
    },
    NOTIFICATION_CONTENT_CUSTOMIZATION: {
        name: 'Customized Notifications Content',
        openInE2eTests: true,
        owner: 'daniel@sayanchor.com'
    },
    AGREEMENT_PDF_AMENDMENTS_LOG: {
        name: 'render amendments-log section in agreement PDF',
        openInE2eTests: false,
        owner: 'aviv@sayanchor.com'
    },
    AGREEMENTS_CSV_EXPORT_V2: {
        name: 'agreements dashboard CSV export with services (one row per service)',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    ENABLE_DRAFTS_AI_SEARCH: {
        name: 'natural-language drafts search input + chips on the drafts dashboard (ANCR-36)',
        openInE2eTests: false,
        owner: 'idan.s@sayanchor.com'
    },
    ENABLE_AGREEMENTS_AI_SEARCH: {
        name: 'natural-language agreements search input + fixed-control materialization on the agreements dashboard (ANCR-2411)',
        openInE2eTests: false,
        owner: 'ben@sayanchor.com'
    },
    PING_INTEGRATION: {
        name: 'Ping integration card on Available Apps page (Communications section)',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    PAYMENT_RECEIPT_PDF: {
        name: 'on-demand payment receipt PDF download from the FullPageInvoice header dropdown',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    FE_CRM: {
        name: 'CRM: Clients table page and sidebar restructuring',
        openInE2eTests: false,
        owner: 'aviv@sayanchor.com'
    },
    ACH_MANDATE_REAUTHORIZATION: {
        name: 'ACH mandate re-authorization states across client and SP payment surfaces (ANCR-3665)',
        openInE2eTests: false,
        owner: 'aviv@sayanchor.com'
    },
    CREDIT_LIFECYCLE_ACTIVITY_ENTRIES: {
        name: 'credit lifecycle entries (added/paused/resumed/canceled) on the activity log (ANCR-3739)',
        openInE2eTests: true,
        owner: 'anna.y@sayanchor.com'
    },
    AGREEMENT_IMPORT_TRANSCRIPT: {
        name: 'allow to import txt files of transcript in the import agreement flow',
        openInE2eTests: false,
        owner: 'meital@sayanchor.com'
    },
    CRM_DRAFT_CONTACTS: {
        name: 'new contact picker in Agreement Studio: primary + additional recipients scoped to one client business (ANCR-2157 / ANCR-2278)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    ANALYST_AGENT: {
        name: 'analyst agent chat on the vendor dashboard',
        openInE2eTests: true,
        owner: 'leeor@sayanchor.com'
    },
    SELF_SERVICE_TAX_UPDATE: {
        name: 'self-service "Update tax details" action launching a Persona tax-update inquiry (ANCR-2948)',
        openInE2eTests: false,
        owner: 'leeor@sayanchor.com'
    },
    SALES_TAX: {
        name: 'sales tax feature — SP tax config, per-service taxable, per-client exemption, invoice tax rendering (ANCR-20)',
        openInE2eTests: true,
        owner: 'aviv@sayanchor.com'
    },
    REFERENCE_FIELDS: {
        name: 'reference fields on proposals, agreements, invoices (ANCR-2541)',
        openInE2eTests: true,
        owner: 'guy.w@sayanchor.com'
    },
    NATIVE_PUSH: {
        name: 'native mobile push notifications',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    APPLE_WEB_LOGIN: {
        name: 'Sign in with Apple on the web signup and login screens (ANCR-3548)',
        openInE2eTests: false,
        owner: 'ahuvi@sayanchor.com'
    },
    SAFE_SVG_SIGNATURE: {
        name: 'render drawn svg signatures as a sandboxed image instead of raw HTML (ANCR-3524 stored XSS fix)',
        openInE2eTests: true,
        owner: 'elad@sayanchor.com'
    },
    BULK_AGENTIC_AMENDMENTS: {
        name: 'bulk agentic amendments pane on AgreementsDashboard (ANCR-788)',
        openInE2eTests: true,
        owner: 'anna@sayanchor.com'
    },
    BILLING_TIMELINE: {
        name: 'billing timeline pane in agreement studio (ANCR-334)',
        openInE2eTests: true,
        owner: 'ahuvi@sayanchor.com'
    },
    CRM_CONTACTS: {
        name: 'contacts table rebuilt on shared contact identities, plus per-client roles (ANCR-2711)',
        openInE2eTests: false,
        owner: 'anna.y@sayanchor.com'
    }
};
export const FeatureFlag = Object.keys(featureFlags).reduce((acc, key)=>{
    acc[key] = key;
    return acc;
}, {});
